import { render, staticRenderFns } from "./applicantList.vue?vue&type=template&id=53c9183c&scoped=true&"
import script from "./applicantList.vue?vue&type=script&lang=js&"
export * from "./applicantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9183c",
  null
  
)

export default component.exports